import {createSelector} from '@ngrx/store';

import {selectAuthState} from '../core.state';
import {AuthState} from '../states/auth-state';

export const selectAuth = createSelector(
  selectAuthState,
  (state: AuthState) => state
);

export const selectAuthToken = createSelector(
  selectAuthState,
  (state: AuthState) => state.access_token
);

export const selectAuthPersonaId = createSelector(
  selectAuthState,
  (state: AuthState) => state.personaId
);

export const selectAuthIsLoading = createSelector(
  selectAuthState,
  (state: AuthState) => state.isLoading
);

export const selectAuthError = createSelector(
  selectAuthState,
  (state: AuthState) => state.error
);

export const selectAuthRole = createSelector(
  selectAuthState,
  (state: AuthState) => state.rolId
);
